// extracted by mini-css-extract-plugin
export var balance = "points-balance-module--balance--aHk+K";
export var content = "points-balance-module--content--It9zO";
export var icon = "points-balance-module--icon--NU5Ah";
export var left = "points-balance-module--left--6Fp5o";
export var loader = "points-balance-module--loader--5hBs6";
export var pointsBalance = "points-balance-module--points-balance--sLNAG";
export var right = "points-balance-module--right--+T8dK";